import { gql } from "@apollo/client";

export default gql`
  mutation banWorker($data: BanWorkerInput!) {
    banWorker(data: $data) {
      id
      employerId
      workerId
      type
      createdAt
      createdAtUtc
      reason
      isNotified
      notifyAfter
      notifyAfterUtc
    }
  }
`;
